import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CompleteHexIcon = createSvgIcon(
  <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0L8 2.25V6.75L4 9L0 6.75V2.25L4 0Z" fill="#FDB928" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.11658 3.58475L3.33778 6.002L1.88342 4.63834L2.26795 4.21875L3.33778 5.24791L5.73205 3.16516L6.11658 3.58475Z"
      fill="currentColor"
      fill-opacity="0.7"
    />
  </svg>,
  'complete-with-hex'
);
